import React, { useEffect, useRef, useState } from "react";
import {
    Table,
    Form,
    Button,
    Col,
    OverlayTrigger,
    Overlay,
    Popover,
    Tooltip,
} from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { useSelectAPIEndpoint } from "../../../../utils/useSelectAPIEndpoint";
import moment from "moment";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import darkNoteIcon from "../../../../Assets/Images/CRM/darkNotes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import DatePicker from "react-datepicker";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";
import SingleDayGroupModal from "../../SingleDayGroupModal";
import { useParams } from "react-router-dom";
import ticket from "../../../../Assets/Images/Revenue-management/tableTicket.svg";
import promo from "../../../../Assets/Images/Revenue-management/promo.svg";

import DemandScore_High from "../../../../Assets/Images/Revenue-management/DemandScore_High.svg";
import DemandScore_Low from "../../../../Assets/Images/Revenue-management/DemandScore_Low.svg";
import DemandScore_Moderate from "../../../../Assets/Images/Revenue-management/DemandScore_Moderate.svg";
import DemandScore_VeryHigh from "../../../../Assets/Images/Revenue-management/DemandScore_VeryHigh.svg";
import DemandScore_VeryLow from "../../../../Assets/Images/Revenue-management/DemandScore_VeryLow.svg";

import soldOutIcon from "../../../../Assets/Images/Revenue-management/soldout.svg";

import {
    errorToastMessage,
    successToastMessage,
} from "../../../../utils/toastMessage";
import ToolsSingleTicketPopUp from "../../../CommonComponent/ToolsSingleTicketPopUp";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import WidgetNote from "../../WidgetNote";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import { FixColumn } from "../../../../utils/dataTable";
import EventViewModal from "../../../CommonComponent/EventViewModal";
import ToolsSummaryModal from "../../ToolsSummaryModal";
import CustomRangePicker from "../../../CommonComponent/CustomRangePIcker";
import SingleDayPricingForcastModal from "../../SingleDayPricingForcastModal";
import FlagPopup from "../DailySummary/FlagPopup";
import PriceSimulatorDetailAnalysis from "../../PriceSimulatorDetailAnalysis";

const UpArrow = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="green"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M7 17L17 7" />
        <path d="M9 7H17V15" />
    </svg>
);
const DownArrow = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="red"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M7 7L17 17" />
        <path d="M9 17H17V9" />
    </svg>
);
const EqualIcon = () => (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none">
        <path
            d="M3 2V10"
            stroke="#4B5563"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <path
            d="M7 2V10"
            stroke="#4B5563"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

const RecommendedRate = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const userDetail = commonService.getLoginUserData();
    const stlyComsetRatesEndpoint = useSelectAPIEndpoint({
        standard: API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
        datewise: API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES_DATEWISE,
    });
    const dummyData = [
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
    ];

    const recommDummyData = [
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
        {
            propertycode: "RRI102",
            staydate: "2026-06-01",
            asofdate: "2026-06-01",
            forecast_rms: 0,
            otb: 0,
            adr: "0",
            ota_finalrate: "0",
            forecast_rate: "0",
            stly_otb: 0,
            stly_adr: "0",
            rms_pace: 0,
            adr_pace: "0",
            rms_pace_1d: 0,
            adr_pace_1d: "0",
            rms_pace_3d: 0,
            adr_pace_3d: "0",
            rms_pace_7d: 0,
            adr_pace_7d: "0",
        },
    ];

    let ooo = 0,
        RmsAvailable = 0,
        leftToSell = 0,
        avgleadtime = 0,
        otb = 0,
        occPercentage = 0,
        adr = 0,
        rev = 0,
        revPar = 0,
        groupOTB = 0,
        groupBlock = 0,
        pickupRooms = 0,
        pickupAdr = 0,
        dayName = false,
        barBasedOTB = 0,
        baeBasedRollingAvg = 0,
        pickupAdrCount = 0,
        threePickupRooms = 0,
        threePickupAdr = 0,
        threePickupAdrCount = 0,
        threePickupRev = 0,
        sevenPickupRooms = 0,
        sevenPickupAdr = 0,
        sevenPickupAdrCount = 0,
        pickupRev = 0,
        sevenPickupRev = 0,
        Total_STLY_ADR_Count = 0,
        Total_STLY_ADR = 0,
        Total_STLY_OTB = 0,
        Total_STLY_Revenue = 0,
        Total_STLY_AVG_Lead_Time = 0,
        Total_STLY_AVG_Lead_Time_Count = 0,
        Total_STLY_AVG_Rate = 0,
        Total_LY_ADR_Count = 0,
        Total_LY_ADR = 0,
        Total_LY_OTB = 0,
        Total_LY_Revenue = 0,
        Total_LY_AVG_Lead_Time = 0,
        Total_LY_AVG_Lead_Time_Count = 0,
        Total_LY_AVG_Rate = 0;

    let OTB_totalOTB = 0,
        OTB_totalOCC = 0,
        OTB_totalADR = 0,
        OTB_totalREV = 0;

    const initTotalPickup = {
        pick_rms: 0,
        pick_adr: 0,
        pick_rev: 0,
    };
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const asOfDate = para?.asOfDate || moment().format("YYYY-MM-DD");
    const date = new Date(asOfDate);
    // const date = new Date();

    const startDate = commonService.getDateInDBFormat(
        new Date(date.getFullYear(), date.getMonth(), date.getDate()),
    );
    const endDate = commonService.getDateInDBFormat(
        new Date(date.getFullYear(), date.getMonth(), date.getDate() + 14),
    );

    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const [orgData, setOrgData] = useState(null);
    const [recommendedData, setRecommendedData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectAsOfDate, setSelectAsOfDate] = useState();
    const [startRangeDate, setStartRangeDate] = useState();
    const [selectPickupDate, setSelectPickupDate] = useState();
    const [selectSevenPickupDate, setSelectSevenPickupDate] = useState();
    const [selectThreePickupDate, setSelectThreePickupDate] = useState();
    const [pickupFromData, setPickupFromData] = useState(null);
    const [pickupFromDataTotal, setPickupFromDataTotal] =
        useState(initTotalPickup);
    const [sevenPickupFromDataTotal, setSevenPickupFromDataTotal] =
        useState(initTotalPickup);
    const [threePickupFromDataTotal, setThreePickupFromDataTotal] =
        useState(initTotalPickup);
    const [sevenPickupFromData, setSevenPickupFromData] = useState(null);
    const [threePickupFromData, setThreePickupFromData] = useState(null);
    const [rateShopListData, setRateShopListData] = useState(null);
    const [past_rateShopListData, setPast_rateShopListData] = useState([]);
    const startRangeDateRef = useRef();
    const endRangeDateRef = useRef();
    const [maxDateForPickupFrom, setMaxDateForPickupFrom] = useState();
    const maxDateRef = useRef();
    const sevenMaxDateRef = useRef();
    const threeMaxDateRef = useRef();
    const singleDatePickupDateRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const selectedTdIndexRef = useRef();
    const dateForNoteRef = useRef();
    const userNoteRef = useRef();
    const eventListRef = useRef();
    const eventListPropsRef = useRef();
    const [showTicketModal, setShowTicketModal] = useState(false);
    const [noteLoading, setNoteLoading] = useState(false);
    if (maxDateForPickupFrom) {
        let date = new Date(maxDateForPickupFrom);
        let sevenDate = new Date(maxDateForPickupFrom);
        let threeDate = new Date(maxDateForPickupFrom);
        maxDateRef.current = date.setDate(date.getDate() - 1);
        sevenMaxDateRef.current = sevenDate.setDate(sevenDate.getDate() - 7);
        threeMaxDateRef.current = threeDate.setDate(threeDate.getDate() - 3);
    }
    const startDateArrayRef = useRef([]);
    const [forecastData, setForecastData] = useState(null);
    const [forecastLoading, setForecastLoading] = useState(null);

    const [barBasedData, setBarBasedData] = useState(null);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail,
    );
    const [selectedForecast, setSelectedForecast] = useState(
        propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term
            ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase()
            : "ema",
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate,
    );
    const [widgetModal, setWidgetModal] = useState(false);
    const [flagModal, setFlagModal] = useState(false);
    const [flagModalData, setFlagModalData] = useState({});
    const widgetDetailRef = useRef();
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [addNoteModal, setAddNoteModal] = useState(false);
    const closeNoteModal = () => {
        setAddNoteModal(false);
    };
   
    const clickedDateForNote = useRef();
    const [noteDetail, setNoteDetail] = useState(null);
    const selectedEventDateRef = useRef();
    const [showToolsSummaryModal, setToolsSummaryModal] = useState(false);
    const [ClickedDate, setClickedDate] = useState(new Date());

    const closeToolsSummaryModal = () => {
        setToolsSummaryModal(false);
    };

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };

    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

  
    const getEventList = async () => {
        let eventList = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(propertyDetailFromRTK?.propertyid),
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false,
        );

        let eventListResponse = apiResponse(false, eventList);

        if (eventListResponse?.isValidate) {
            let eventListArr = [];

            eventListResponse?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                } catch (err) { }
            });
            eventListRef.current = eventListArr;
        }

        if (!eventListResponse?.isValidate) {
            eventListRef.current = [];
        }
    };

    const [FLAG_MECHANISM, setFLAG_MECHANISM] = useState([]);

    const getFLAG_MECHANISM = async () => {
        let startDateMinus = new Date(
            commonService.getDateInDBFormat(
                startRangeDateRef.current ? startRangeDateRef.current : startDate,
            ),
        );
        startDateMinus = new Date(
            startDateMinus.setDate(startDateMinus.getDate() - 2),
        );
        let endDatePlus = new Date(
            commonService.getDateInDBFormat(
                endRangeDateRef.current ? endRangeDateRef.current : endDate,
            ),
        );
        endDatePlus = new Date(endDatePlus.setDate(endDatePlus.getDate() + 2));
        let List = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.FLAG_MECHANISM,
                body: {
                    asofdate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startdate: commonService.getDateInDBFormat(startDateMinus),
                    enddate: commonService.getDateInDBFormat(endDatePlus),
                    // enddate: endDatePlus,

                    propertyCode: para?.propertyCode,
                },
            },
            false,
        );

        let Response = apiResponse(false, List);

        if (Response?.isValidate) {
            setFLAG_MECHANISM(Response.data.data);
        }

        if (!Response?.isValidate) {
        }
    };

    const getORGDetail = async () => {
        setLoading(true);

        await getEventList();
        await getFLAG_MECHANISM();
        let orgDetailResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.ORG,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyCode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, orgDetailResponse);

        if (response?.isValidate) {
            setOrgData(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setOrgData(dummyData);
            setLoading(false);
        }
    };

    const getRecommendedDetail = async () => {
        setLoading(true);
        let resData = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.RECOMMENDED_RATE,
                body: {
                    asofdate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startdate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    enddate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertycode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, resData);

        if (response?.isValidate) {
            setRecommendedData(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setRecommendedData(recommDummyData);
            setLoading(false);
        }
        setLoading(false);
    };

    const getPickupFromData = async () => {
        setLoading(true);
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 1);
        singleDatePickupDateRef.current = pickupDate;
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PICKUP_FROM,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    pickupDate: selectPickupDate
                        ? moment(selectPickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertyCode: para?.propertyCode,
                    ForcastType: propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema"
                },
            },
            false,
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                // let dateForTd = new Date(
                //   startDateFromParent ? startDateFromParent : startDate
                // );
                // item.date = commonService.getDateInDBFormat(
                //   dateForTd.setDate(dateForTd.getDate() + index)
                // );

                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });
            setPickupFromDataTotal(response?.data?.data?.total_pickup?.[0]);
            setPickupFromData(pickupFromData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setPickupFromDataTotal(initTotalPickup);
            setLoading(false);
            setPickupFromData(null);
        }
    };

    const [STLY_LY_COMSET_Rates, setSTLY_LY_COMSET_Rates] = useState(null);

    const getsetSTLY_LY_COMSET_Rates = async () => {

        setLoading(true);
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 1);
        singleDatePickupDateRef.current = pickupDate;
        let ComsetRatesResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + stlyComsetRatesEndpoint,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyCode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, ComsetRatesResponse);

        if (response?.isValidate) {
            setSTLY_LY_COMSET_Rates(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setLoading(false);
            setSTLY_LY_COMSET_Rates(null);
        }
    };

    const getSevenPickupFromData = async () => {
        setLoading(true);
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 7);
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PICKUP_FROM,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    pickupDate: selectSevenPickupDate
                        ? moment(selectSevenPickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertyCode: para?.propertyCode,
                    ForcastType: propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema"
                },
            },
            false,
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });

            setSevenPickupFromDataTotal(response?.data?.data?.total_pickup?.[0]);
            setSevenPickupFromData(pickupFromData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setSevenPickupFromDataTotal(initTotalPickup);
            setLoading(false);
            setSevenPickupFromData(null);
        }
    };

    const getThreePickupFromData = async () => {
        setLoading(true);
        let pickupDate = new Date(para?.asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 3);
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PICKUP_FROM,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    pickupDate: selectThreePickupDate
                        ? moment(selectThreePickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertyCode: para?.propertyCode,
                    ForcastType: propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema"
                },
            },
            false,
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });
            setThreePickupFromDataTotal(response?.data?.data?.total_pickup?.[0]);
            setThreePickupFromData(pickupFromData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setThreePickupFromDataTotal(initTotalPickup);
            setLoading(false);
            setThreePickupFromData(null);
        }
    };

    const rateShopListAsOfDate = async () => {
        setLoading(true);

        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false,
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);

        let CompareDate = new Date(
            selectAsOfDate ? selectAsOfDate : para?.asOfDate,
        );
        CompareDate = CompareDate.setDate(CompareDate.getDate() - 1);

        let rateShopListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    propertyCode: para?.propertyCode,
                    Channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyid: propertyDetailFromRTK?.propertyid,
                    CompareDate: CompareDate
                        ? commonService.getDateInDBFormat(CompareDate)
                        : "",
                },
            },
            false,
        );

        let response = apiResponse(false, rateShopListResponse);
        if (response?.isValidate) {
            let rateShopData = response?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });

            let distinctData = [];

            rateShopData.forEach((item) => {
                let existing = distinctData.find(
                    (x) =>
                        x.CompetitorID === item.CompetitorID &&
                        x.CheckInDate === item.CheckInDate,
                );

                if (!existing) {
                    distinctData.push({ ...item });
                } else {
                    existing.Rate = Math.min(
                        parseFloat(existing.Rate),
                        parseFloat(item.Rate),
                    ).toFixed(2);
                    existing.PrevRate = Math.min(
                        parseFloat(existing.PrevRate),
                        parseFloat(item.PrevRate),
                    ).toFixed(2);
                    existing.RateDifference = Math.min(
                        parseFloat(existing.RateDifference),
                        parseFloat(item.RateDifference),
                    ).toFixed(2);
                }
            });

            setRateShopListData(distinctData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setRateShopListData(null);
            setLoading(false);
        }
    };

    const [propertyChannel, setpropertyChannel] = useState("");

    const past_rateShopListAsOfDate = async () => {
        setLoading(true);

        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false,
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);
        let PevAsOfDate = new Date(
            selectAsOfDate ? selectAsOfDate : para?.asOfDate,
        );
        PevAsOfDate = new Date(date.setDate(PevAsOfDate.getDate() - 1));
        setpropertyChannel(
            propertyResponse?.data?.data?.channel_term
                ? propertyResponse?.data?.data?.channel_term
                : "",
        );
        let rateShopListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.PAST_RATESHOP_LIST,
                body: {
                    AsOfDate: commonService.getDateForNode(PevAsOfDate),
                    propertyCode: para?.propertyCode,
                    Channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyid: propertyDetailFromRTK?.propertyid,
                },
            },
            false,
        );

        let response = apiResponse(false, rateShopListResponse);
        if (response?.isValidate) {
            let rateShopData = response?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index),
                );
                return item;
            });
            setPast_rateShopListData(rateShopData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setPast_rateShopListData([]);
            setLoading(false);
        }
    };

    const saveNote = async () => {
        let saveResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.SAVE_UPDATE,
                body: {
                    propertyCode: para?.propertyCode,
                    Dates: dateForNoteRef.current,
                    UserNotes: userNoteRef.current,
                },
            },
            false,
        );

        let response = apiResponse(true, saveResponse, setNoteLoading);

        if (response?.isValidate) {
            // successToastMessage(response?.data?.message);
            // setNoteUpdate(!noteUpdate);
        }
        if (!response?.isValidate) {
            errorToastMessage(response?.data?.message);
            // setNoteUpdate(!noteUpdate);
        }
    };

    const getForecastDetail = async () => {
        setForecastLoading(true);
        let forecastResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.PRICING_FORECAST,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyCode: para?.propertyCode,
                    propertyid: para?.propertyDetail?.propertyid,
                    ForcastType: (selectedForecast
                        ? selectedForecast
                        : "ema"
                    ).toLowerCase(),
                },
            },
            false,
        );

        let response = apiResponse(false, forecastResponse);

        if (response?.isValidate) {
            setForecastData(response?.data?.data);
            setForecastLoading(false);
        }

        if (!response?.isValidate) {
            setForecastData([]);
            setForecastLoading(false);
        }
    };

    const getBarBasedDetail = async () => {
        let barBasedResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.BAR_BASED_STATS,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : para?.asOfDate,
                    startDate: startRangeDateRef.current
                        ? startRangeDateRef.current
                        : startDate,
                    endDate: endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    propertyCode: para?.propertyCode,
                },
            },
            false,
        );

        let response = apiResponse(false, barBasedResponse);

        if (response?.isValidate) {
            setBarBasedData(response?.data?.data);
        }
        if (!response?.isValidate) {
            setBarBasedData(null);
        }
    };

    const getNoteByDataList = async () => {
        let noteByDataListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.WIDGET_NOTE.GET_BY_DATA_LIST,
                body: {
                    propertyid: propertyDetailFromRTK?.propertyid,
                    // widgetid: para?.widgetId,
                    widgetid: 0,
                    startdate: startRangeDateRef.current
                        ? commonService.getDateInDBFormat(startRangeDateRef.current)
                        : commonService.getDateInDBFormat(startDate),
                    enddate: endRangeDateRef.current
                        ? commonService.getDateInDBFormat(endRangeDateRef.current)
                        : commonService.getDateInDBFormat(endDate),
                },
            },
            false,
        );

        let response = apiResponse(false, noteByDataListResponse);

        if (response?.isValidate) {
            setNoteDetail(response?.data?.data);
        }

        if (!response?.isValidate) {
            setNoteDetail(null);
        }
    };

    const callBothApi = async () => {
        await rateShopListAsOfDate();
        getORGDetail();
        getRecommendedDetail();
        getPickupFromData();
        getSevenPickupFromData();
        getThreePickupFromData();
        past_rateShopListAsOfDate();
        getForecastDetail();
        getBarBasedDetail();
        getNoteByDataList();
        getFLAG_MECHANISM();
        getsetSTLY_LY_COMSET_Rates();
    };

    useEffect(() => {
        if (api === 0) {
            let datesArr = commonService.getDateBetweenTwoDates(
                new Date(startDate),
                new Date(endDate),
            );
            startDateArrayRef.current = datesArr;
            setOrgData(dummyData);
            setRecommendedData(recommDummyData);
        } else {
            if (para?.asOfDate) {
                setSelectAsOfDate(para?.asOfDate);
                let datesArr = commonService.getDateBetweenTwoDates(
                    commonService.convertDateInTimezone(
                        startRangeDateRef.current ? startRangeDateRef.current : startDate,
                    ),
                    commonService.convertDateInTimezone(
                        endRangeDateRef.current ? endRangeDateRef.current : endDate,
                    ),
                );
                startDateArrayRef.current = datesArr;
                // setMaxDateForPickupFrom(new Date(para?.asOfDate));
                setMaxDateForPickupFrom(new Date(para?.defaultAsOfDate));
                if (para?.asOfDate && selectAsOfDate && selectedForecast) {
                    callBothApi();
                }
            }
        }
        //if (!selectAsOfDate) {
        //    setSelectAsOfDate(para?.asOfDate);
        //}
    }, [para?.asOfDate, selectAsOfDate, selectedForecast]);

    useEffect(() => {
        setSelectAsOfDate(asOfDateFromRTK);
    }, [asOfDateFromRTK]);

    useEffect(() => {
        if (selectPickupDate) {
            getPickupFromData();
        }
    }, [selectPickupDate]);
    useEffect(() => {
        if (selectSevenPickupDate) {
            getSevenPickupFromData();
        }
    }, [selectSevenPickupDate]);

    useEffect(() => {
        if (selectThreePickupDate) {
            getThreePickupFromData();
        }
    }, [selectThreePickupDate]);

    const [tblids, settblids] = useState({
        OrgStrategyTable: commonService.GenerateGUID(),
    });
    //commonService.setBackColorPerByTDValue(
    //    "#638EC6",
    //    "Red",
    //    `#${tblids.OrgStrategyTable} .perbackground-otb`
    //);
    //commonService.setBackColorPerByTDValue(
    //    "Green",
    //    "Red",
    //    `#${tblids.OrgStrategyTable} .perbackground-adr`
    //);

    commonService.setBackColorPerByTDValueInPercentage(
        "Green",
        "Red",
        `#${tblids.OrgStrategyTable} .TotalOCCPercentage`,
    );

    commonService.setBackColorPerByTDValueInPercentage(
        "#FFDEA1",
        "Red",
        `#${tblids.OrgStrategyTable} .perbackground-GroupOTB`,
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.OrgStrategyTable} .perbackground-room`,
    );

    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        // Property: { top: 0, left: 0 },
        Target: null,
        Position: "top",
    });
    const orgStrategyTableRef = useRef(null);
    const [pricingForcastModal, setPricingForcastModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    const [groupModal, setGroupModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const selectedData = useRef();

    const [DetailedAnalysis, setDetailedAnalysis] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    useEffect(() => {
        if (orgStrategyTableRef.current) {
            orgStrategyTableRef.current.addEventListener(
                "click",
                handleOrgStrategyTableClick,
            );
        }

        return () => {
            if (orgStrategyTableRef.current) {
                orgStrategyTableRef.current.removeEventListener(
                    "click",
                    handleOrgStrategyTableClick,
                );
            }
        };
    }, []);

    const handleOrgStrategyTableClick = (event) => { };

    const handleFilterBtnClick = (event) => {
        // let screenY = event.screenY;
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        // let Left = event.nativeEvent.layerX + 30;
        if (Top + 400 > window.innerHeight) {
            // Top = Top - 400;
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        // setONTHEBOOKS({ IsDisplay: false, Property: { top: 0, left: 0 } });
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const closeDetailedAnalysisModal = () => {
        setDetailedAnalysis({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const handleGroupBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setGroupModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeGroupDate = () => {
        selectedTdIndexRef.current = -1;
        setGroupModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const handlePricingForecastBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setPricingForcastModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closePricingForecastDate = () => {
        selectedTdIndexRef.current = -1;
        setPricingForcastModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const handleExport = async (type) => {
        let tableId = document.querySelector(".dailySummaryTbl");

        if (tableId.querySelector(".loding-animation")) {
            errorToastMessage("Wait for the data loading.");
            return;
        }

        let groupingJson = {
            data: [],
            filename: `${para?.propertyCode}-DailySummary-${moment(new Date()).format(
                "MMDDYYYY",
            )}`,
        };
        let groupingTable = [
            {
                widgetname: "ORG",
                rowdata: [],
            },
        ];
        let totalJson = [
            {
                widgetname: "BlankCommon",
                rowdata: [],
            },
        ];

        groupingTable[0].rowdata.push({
            data: [para?.rowTitle ? para?.rowTitle : ""],
        });
        groupingTable[0].rowdata.push({
            data: [],
        });

        const getTable = document.querySelector(".dailySummaryTbl");

        const findTblHeader = getTable?.querySelectorAll("thead tr");
        const findTblTbody = getTable?.querySelectorAll("tbody tr");

        findTblHeader.forEach((tblHeaderItem, tblHeaderIndex) => {
            let allTh = tblHeaderItem.querySelectorAll("th");
            let allThValue = [];
            allTh.forEach((thItem) => {
                let thSpan = thItem?.querySelector("div>span");
                let thText = thItem?.innerText;
                allThValue.push(
                    thSpan
                        ? thSpan.innerText.toUpperCase() === "EMA"
                            ? "SYSTEM"
                            : thSpan.innerText
                        : thText,
                );
            });

            groupingTable[0].rowdata.push({ data: allThValue });
            if (tblHeaderIndex === 0) {
                groupingTable[0].rowdata.push({ data: [] });
            }
        });

        findTblTbody.forEach((tblBodyItem, tblBodyIndex) => {
            let allTd = tblBodyItem.querySelectorAll("td");
            let allTdValue = [],
                tdTotalValue = [];

            allTd.forEach((tdItem, tdIndex) => {
                let tdText = tdItem?.innerText;
                if (tdIndex === 5 || tdIndex === 16 || tdIndex === 17) {
                    if (findTblTbody?.length - 1 !== tblBodyIndex) {
                        tdText = tdText?.replace("$", "");
                    }
                }
                if (allTd[0].innerText === "Total") {
                    tdTotalValue.push(tdText ? tdText : "");
                } else {
                    allTdValue.push(tdText ? tdText : "");
                }
            });
            if (allTdValue?.length > 0) {
                groupingTable[0].rowdata.push({ data: allTdValue });
            }
            if (tdTotalValue?.length > 0) {
                totalJson[0].rowdata.push({ data: tdTotalValue });
            }
        });
        if (groupingTable?.[0].rowdata?.length > 0) {
            groupingJson.data = [...groupingJson.data, ...groupingTable];
        }
        if (totalJson?.[0].rowdata?.length > 0) {
            groupingJson.data = [...groupingJson.data, ...totalJson];
        }
        groupingJson = {
            ...groupingJson,
            snapshotid: snapshotId ? parseInt(snapshotId) : 0,
            sendtoemails: userDetail?.email ? userDetail?.email : "",
            actiontype: type,
            asofdata: para?.asOfDate
                ? commonService.getDateInDBFormat(para?.asOfDate)
                : "",
        };
        await commonService.widgetWiseExportExcel(groupingJson);
    };

    FixColumn(tblids.OrgStrategyTable, [1]);

    const renderTooltip = (message, item) => (
        <Popover id="popover-id" className="tooltip-flag">
            <div className="m-2">{message}</div>
            <div className="d-flex justify-content-center mb-2">
                <Button id={commonService.generateGlobalClickTrackerID("RecommendedRate", "ask-rm-copilot", item)}
                    onClick={() => {
                        setFlagModal(true);
                        setFlagModalData({
                            asofdate: para?.asOfDate,
                            dates: item,
                            propertycode: para?.propertyCode,
                        });
                    }}
                >
                    Ask RM Copilot
                </Button>
            </div>
        </Popover>
    );

    const safeDivide = (a, b) => (b ? a / b : 0);

    const handleDetailAnalysisClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setDetailedAnalysis({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const getPaceClass = (value) => {
        const num = Number(value) || 0;

        if (num > 0) return "greenText";
        if (num < 0) return "redText";
        return "text-secondary";
    };

    const formatPaceValue = (value, isShowDoller) => {
        const num = Number(value) || 0;

        if (num > 0) {
            return `+${isShowDoller ? commonService.formateAmount(num) : commonService.formateRoom(num)}`;
        }

        return isShowDoller
            ? commonService.formateAmount(num)
            : commonService.formateRoom(num);
    };

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RecommendedRate", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.org,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("RecommendedRate", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                if (
                                    window.location.href.includes("RevPAK%20Summary") ||
                                    window.location.href.includes("Daily%20Summary%20(RevPAK)")
                                ) {
                                    handleExport("EMAIL");
                                } else {
                                    commonService.fnSendWidgetMail(
                                        tblids?.OrgStrategyTable,
                                        "RecommendedRate",
                                        snapshotId,
                                        defaultAsOfDateFromRTK,
                                        "",
                                        para?.widgetId,
                                    );
                                }
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RecommendedRate", "download", propertyCode)}
                            src={downloadIcon}
                            alt="download"
                            import={tblids?.OrgStrategyTable}
                            onClick={() => {
                                if (
                                    window.location.href.includes("RevPAK%20Summary") ||
                                    window.location.href.includes("Daily%20Summary%20(RevPAK)")
                                ) {
                                    handleExport("DOWNLOAD");
                                } else {
                                    commonService.fnExportInCSV(
                                        tblids?.OrgStrategyTable,
                                        // "Strategy"
                                        `${para?.propertyCode}-RecommendedRate-${moment(new Date()).format(
                                            "MMDDYYYY",
                                        )}`,
                                    );
                                }
                            }}
                        />
                    </Button>
                </div>
            )}
            <div className="ViewPropertySetupTable mainTableClass">
                <div className="stripped__table">
                    <div className="table-responsive tblDynamicPickupSticky">
                        <Table
                            id={tblids.OrgStrategyTable}
                            className="table-with-spacing positionStaticTable dailySummaryTbl"
                            ref={orgStrategyTableRef}
                        >
                            <thead className="tbl-header-sticky">
                                <tr className="diff-bg-tr table-main-header-tr">
                                    <th className="border-right text-center"></th>
                                    <th className="border-right text-center" colSpan={6}>
                                        ON THE BOOKS
                                    </th>

                                    <th className="border-right text-center">Forecast</th>



                                    {rateShopListData ? (
                                        <>
                                            <th className="border-right text-center" colSpan={3}>
                                                COMP SET
                                            </th>
                                            <th className="border-right text-center" colSpan={2}>
                                                Pricing
                                            </th>
                                            <th className="border-right text-center"></th>
                                        </>
                                    ) : (
                                        <th className="border-right text-center"></th>
                                    )}

                                    <th className="border-right text-center" colSpan={7}>
                                        STLY
                                    </th>
                                    <th className="border-right text-center" colSpan={7}>
                                        LY
                                    </th>

                                </tr>
                                <tr className="table-main-header-tr">
                                    <th className="width175">Date </th>

                                    <th className="width75 text-center border-right">OOO\Rooms Available</th>
                                    <th className="width75 text-center">OTB</th>
                                    <th className="text-center">Occ%</th>
                                    <th className="text-end">ADR</th>
                                    <th className="text-end">Rev</th>
                                    <th className="text-end">RevPAR</th>

                                    {/* <th className="text-center border-right">FC OCC</th> */}
                                    <th className="text-center border-right">FC RMS</th>

                                    {rateShopListData ? (
                                        <>

                                            <th className="text-end border-right">STLY</th>
                                            <th className="text-center" colSpan={2}>
                                                AVG
                                            </th>


                                            <th className="text-center border-right" colSpan={2}>
                                                BAR
                                            </th>


                                            <th className="text-center border-right">REC RATE</th>

                                        </>
                                    ) : (
                                        <th className="border-right text-center">REC RATE</th>
                                    )}

                                    <th className="text-center border-right" colSpan="2">OTB</th>
                                    <th className="text-center border-right" colSpan="2">ADR</th>
                                    <th className="text-center border-right" colSpan="2">Rev</th>
                                    <th className="text-center border-right">AVG LT</th>

                                    <th className="text-center border-right" colSpan="2">OTB</th>
                                    <th className="text-center border-right" colSpan="2">ADR</th>
                                    <th className="text-center border-right" colSpan="2">Rev</th>
                                    <th className="text-center border-right">AVG LT</th>

                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr style={{ height: "80px", position: "relative" }}>
                                        <Loader />
                                    </tr>
                                ) : (
                                    startDateArrayRef.current?.map((item, index) => {
                                        dayName = false;
                                        if (
                                            moment(new Date(item), "l").format("ddd") === "Fri" ||
                                            moment(new Date(item), "l").format("ddd") === "Sat"
                                        ) {
                                            dayName = true;
                                        }

                                        let singlePickupData = pickupFromData?.filter(
                                            (x) =>
                                                moment(x.Dates).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let threePickupData = threePickupFromData?.filter(
                                            (x) =>
                                                moment(x.Dates).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let sevenPickupData = sevenPickupFromData?.filter(
                                            (x) =>
                                                moment(x.Dates).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let singleOTBData = orgData?.filter(
                                            (x) =>
                                                moment(x.Date).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let singleRecommendedData = recommendedData?.filter(
                                            (x) =>
                                                moment(x.staydate).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        OTB_totalOTB =
                                            OTB_totalOTB + Number(singleOTBData?.[0]?.OnTheBook || 0);
                                        OTB_totalOCC =
                                            OTB_totalOCC +
                                            Number(singleOTBData?.[0]?.TotalOCCPercentage || 0);
                                        OTB_totalADR =
                                            OTB_totalADR + Number(singleOTBData?.[0]?.ADR || 0);
                                        OTB_totalREV =
                                            OTB_totalREV + Number(singleOTBData?.[0]?.REV || 0);

                                        ooo =
                                            ooo +
                                            (singleOTBData?.[0]?.OOO ? singleOTBData?.[0]?.OOO : 0);
                                        RmsAvailable =
                                            RmsAvailable +
                                            (singleOTBData?.[0]?.RoomAvailable
                                                ? singleOTBData?.[0]?.RoomAvailable
                                                : 0);
                                        leftToSell =
                                            leftToSell +
                                            (singleOTBData?.[0]?.LeftToSell
                                                ? singleOTBData?.[0]?.LeftToSell
                                                : 0);
                                        avgleadtime =
                                            avgleadtime +
                                            (singleOTBData?.[0]?.avgleadtime
                                                ? singleOTBData?.[0]?.avgleadtime
                                                : 0);
                                        otb =
                                            otb +
                                            (singleOTBData?.[0]?.OnTheBook
                                                ? singleOTBData?.[0]?.OnTheBook
                                                : 0);
                                        occPercentage =
                                            occPercentage +
                                            (singleOTBData?.[0]?.TotalOCCPercentage
                                                ? singleOTBData?.[0]?.TotalOCCPercentage
                                                : 0);
                                        adr =
                                            adr +
                                            (singleOTBData?.[0]?.ADR ? singleOTBData?.[0]?.ADR : 0);
                                        rev =
                                            rev +
                                            (singleOTBData?.[0]?.REV ? singleOTBData?.[0]?.REV : 0);
                                        revPar =
                                            revPar +
                                            (singleOTBData?.[0]?.RevPAR
                                                ? singleOTBData?.[0]?.RevPAR
                                                : 0);
                                        groupOTB =
                                            groupOTB +
                                            (singleOTBData?.[0]?.OTB ? singleOTBData?.[0]?.OTB : 0);
                                        groupBlock =
                                            groupBlock +
                                            (singleOTBData?.[0]?.Block
                                                ? singleOTBData?.[0]?.Block
                                                : 0);
                                        pickupRooms =
                                            pickupRooms +
                                            (singlePickupData?.[0]?.RMS
                                                ? singlePickupData?.[0]?.RMS
                                                : 0);
                                        pickupAdr =
                                            pickupAdr +
                                            (singlePickupData?.[0]?.ADR
                                                ? singlePickupData?.[0]?.ADR
                                                : 0);

                                        pickupRev =
                                            pickupRev +
                                            (singlePickupData?.[0]?.REV
                                                ? singlePickupData?.[0]?.REV
                                                : 0);

                                        if (singlePickupData?.[0]?.ADR) {
                                            if (singlePickupData?.[0]?.ADR !== 0) {
                                                pickupAdrCount = pickupAdrCount + 1;
                                            }
                                        }

                                        sevenPickupRooms =
                                            sevenPickupRooms +
                                            (sevenPickupData?.[0]?.RMS
                                                ? sevenPickupData?.[0]?.RMS
                                                : 0);
                                        sevenPickupAdr =
                                            sevenPickupAdr +
                                            (sevenPickupData?.[0]?.ADR
                                                ? sevenPickupData?.[0]?.ADR
                                                : 0);
                                        if (sevenPickupData?.[0]?.ADR) {
                                            if (sevenPickupData?.[0]?.ADR !== 0) {
                                                sevenPickupAdrCount = sevenPickupAdrCount + 1;
                                            }
                                        }


                                        sevenPickupRev =
                                            sevenPickupRev +
                                            (sevenPickupData?.[0]?.REV
                                                ? sevenPickupData?.[0]?.REV
                                                : 0);

                                        /*Three Day*/

                                        threePickupRooms =
                                            threePickupRooms +
                                            (threePickupData?.[0]?.RMS
                                                ? threePickupData?.[0]?.RMS
                                                : 0);
                                        threePickupAdr =
                                            threePickupAdr +
                                            (threePickupData?.[0]?.ADR
                                                ? threePickupData?.[0]?.ADR
                                                : 0);
                                        if (threePickupData?.[0]?.ADR) {
                                            if (threePickupData?.[0]?.ADR !== 0) {
                                                threePickupAdrCount = threePickupAdrCount + 1;
                                            }
                                        }


                                        threePickupRev =
                                            threePickupRev +
                                            (threePickupData?.[0]?.REV
                                                ? threePickupData?.[0]?.REV
                                                : 0);

                                        let singleForecastData = forecastData?.filter(
                                            (x) =>
                                                moment(x.Dates).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let singleBarBasedData = barBasedData?.filter(
                                            (x) =>
                                                moment(x.StayDate).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        barBasedOTB =
                                            barBasedOTB +
                                            (singleBarBasedData?.[0]?.OTB
                                                ? parseInt(singleBarBasedData?.[0]?.OTB)
                                                : 0);

                                        baeBasedRollingAvg =
                                            baeBasedRollingAvg +
                                            (singleBarBasedData?.[0]?.["8 Week Rolling AVG"]
                                                ? parseInt(
                                                    singleBarBasedData?.[0]?.["8 Week Rolling AVG"],
                                                )
                                                : 0);

                                        let isSelfData = rateShopListData?.filter((x) => {
                                            if (
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === true
                                            ) {
                                                return x;
                                            }
                                        });

                                        let SelfDataRateDiff = 0;

                                        let past_isSelfData = past_rateShopListData?.filter((x) => {
                                            if (
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === true
                                            ) {
                                                return x;
                                            }
                                        });

                                        if (
                                            past_isSelfData &&
                                            past_isSelfData.length > 0 &&
                                            isSelfData &&
                                            isSelfData.length > 0
                                        ) {
                                            let PDRate = past_isSelfData[0]?.Rate
                                                ? past_isSelfData[0]?.Rate
                                                : 0;
                                            let Rate = isSelfData[0]?.Rate ? isSelfData[0]?.Rate : 0;
                                            SelfDataRateDiff = parseInt(PDRate) - parseInt(Rate);
                                        }

                                        let rateShoptotal = 0;
                                        rateShopListData?.map((x) => {
                                            if (
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false
                                            ) {
                                                rateShoptotal = rateShoptotal + parseFloat(x?.Rate);
                                            }
                                        });

                                        let findCompetitorData = rateShopListData?.filter(
                                            (x) =>
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false,
                                        );

                                        let past_findCompetitorData = past_rateShopListData?.filter(
                                            (x) =>
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false,
                                        );

                                        let findDataForAvgCount = rateShopListData?.filter(
                                            (x) =>
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false &&
                                                parseFloat(x.Rate) > 0,
                                        );

                                        let avgCompetitor =
                                            rateShoptotal > 0 && findDataForAvgCount?.length > 0
                                                ? Math.round(
                                                    rateShoptotal / findDataForAvgCount?.length,
                                                )
                                                : 0;

                                        let past_rateShoptotal = 0;

                                        past_rateShopListData?.map((x) => {
                                            if (
                                                x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x.IsSelf === false
                                            ) {
                                                past_rateShoptotal =
                                                    past_rateShoptotal + parseFloat(x?.Rate);
                                            }
                                        });

                                        let past_findDataForAvgCount =
                                            past_rateShopListData?.filter(
                                                (x) =>
                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                    x.IsSelf === false &&
                                                    parseFloat(x.Rate) > 0,
                                            );

                                        let past_avgCompetitor =
                                            past_rateShoptotal > 0 &&
                                                past_findDataForAvgCount?.length > 0
                                                ? Math.round(
                                                    past_rateShoptotal /
                                                    past_findDataForAvgCount?.length,
                                                )
                                                : 0;

                                        let avgCompetitorRateDiff = 0;

                                        avgCompetitorRateDiff =
                                            parseInt(past_avgCompetitor) - parseInt(avgCompetitor);

                                        let dataExistsOrNot = rateShopListData?.filter((x) => {
                                            if (
                                                x?.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                x?.IsSelf === false
                                            ) {
                                                return x;
                                            }
                                        });

                                        let checkEvent = eventListRef.current?.filter((x) => {
                                            let checkingDate = moment(item);
                                            let startingDate = moment(x?.startDate);
                                            let endingDate = moment(x?.endDate);
                                            if (
                                                checkingDate.isSameOrAfter(startingDate) &&
                                                checkingDate.isSameOrBefore(endingDate)
                                            ) {
                                                return x;
                                            }
                                        });

                                        let foreCastSpiderTextColor = "";
                                        let forecastSpiderBorder = "";
                                        if (
                                            singleForecastData?.[0]?.RMS <
                                            singleForecastData?.[0]?.R28AVG
                                        ) {
                                            foreCastSpiderTextColor = "redText";
                                            let R28AvgPercentage =
                                                (singleForecastData?.[0]?.R28AVG * 10) / 100;
                                            let finalValue =
                                                singleForecastData?.[0]?.R28AVG - R28AvgPercentage;
                                            if (singleForecastData?.[0]?.RMS < finalValue) {
                                                forecastSpiderBorder = "redBorderTd";
                                            }
                                        } else {
                                            let R28AvgPercentage =
                                                (singleForecastData?.[0]?.R28AVG * 10) / 100;
                                            let finalValue =
                                                singleForecastData?.[0]?.R28AVG + R28AvgPercentage;
                                            if (singleForecastData?.[0]?.RMS > finalValue) {
                                                forecastSpiderBorder = "blackBorderTd";
                                            }
                                        }

                                        let checkNoteExists = noteDetail?.notedata?.filter(
                                            (x) =>
                                                moment(x?.datadate).format("YYYY-MM-DD") ===
                                                moment(item).format("YYYY-MM-DD"),
                                        );

                                        let flagType = null;
                                        let flagvalue = "0";
                                        if (FLAG_MECHANISM && FLAG_MECHANISM.length > 0) {
                                            let flagdata = FLAG_MECHANISM.filter(
                                                (x) =>
                                                    moment(x.dates).format("YYYY-MM-DD") ===
                                                    moment(item).format("YYYY-MM-DD"),
                                            );
                                            if (flagdata && flagdata.length > 0) {
                                                if (flagdata[0]?.demandtag) {
                                                    if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "HIGH"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_High}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    } else if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "LOW"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                message={flagdata[0]?.message}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_Low}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    } else if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "MODERATE"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                message={flagdata[0]?.message}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_Moderate}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    } else if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "VERYHIGH"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                message={flagdata[0]?.message}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_VeryHigh}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    } else if (
                                                        flagdata[0]?.demandtag
                                                            .toUpperCase()
                                                            .replaceAll(" ", "") === "VERYLOW"
                                                    ) {
                                                        flagType = (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                delay={{ show: 250, hide: 2000 }}
                                                                message={flagdata[0]?.message}
                                                                overlay={renderTooltip(
                                                                    flagdata[0]?.message,
                                                                    item,
                                                                )}
                                                            >
                                                                <img
                                                                    src={DemandScore_VeryLow}
                                                                    alt=""
                                                                    style={{ height: "11px", width: "11px" }}
                                                                />
                                                            </OverlayTrigger>
                                                        );
                                                    }
                                                }

                                                if (flagdata[0]?.flag_value) {
                                                    flagvalue = flagdata[0]?.flag_value;
                                                }
                                            }
                                        }
                                        let STLY_ADR = 0;
                                        let STLY_OTB = 0;
                                        let STLY_Revenue = 0;
                                        let STLY_AVG_Lead_Time = 0;
                                        let STLY_AVG_Rate = 0;



                                        let LY_ADR = 0;
                                        let LY_OTB = 0;
                                        let LY_Revenue = 0;
                                        let LY_AVG_Lead_Time = 0;
                                        let LY_AVG_Rate = 0;



                                        if (
                                            STLY_LY_COMSET_Rates &&
                                            STLY_LY_COMSET_Rates.length > 0
                                        ) {
                                            let findByDate = STLY_LY_COMSET_Rates.filter(
                                                (x) =>
                                                    moment(x.dates).format("YYYY-MM-DD") ===
                                                    moment(item).format("YYYY-MM-DD"),
                                            );
                                            if (findByDate && findByDate.length > 0) {
                                                STLY_ADR = findByDate[0].stlyadr
                                                    ? findByDate[0].stlyadr
                                                    : 0;
                                                STLY_OTB = findByDate[0].stlyotb
                                                    ? findByDate[0].stlyotb
                                                    : 0;
                                                STLY_Revenue = findByDate[0].stlyrevenue
                                                    ? findByDate[0].stlyrevenue
                                                    : 0;
                                                STLY_AVG_Lead_Time = findByDate[0].stlyavgleadtime
                                                    ? findByDate[0].stlyavgleadtime
                                                    : 0;
                                                STLY_AVG_Rate = findByDate[0].stlyavgrate
                                                    ? findByDate[0].stlyavgrate
                                                    : 0;

                                                LY_ADR = findByDate[0].lyadr ? findByDate[0].lyadr : 0;
                                                LY_OTB = findByDate[0].lyotb ? findByDate[0].lyotb : 0;
                                                LY_Revenue = findByDate[0].lyrevenue
                                                    ? findByDate[0].lyrevenue
                                                    : 0;
                                                LY_AVG_Lead_Time = findByDate[0].lyavgleadtime
                                                    ? findByDate[0].lyavgleadtime
                                                    : 0;
                                                LY_AVG_Rate = findByDate[0].lyavgrate
                                                    ? findByDate[0].lyavgrate
                                                    : 0;

                                                if (STLY_ADR > 0) {
                                                    Total_STLY_ADR_Count = Total_STLY_ADR_Count + 1;
                                                    Total_STLY_ADR = Total_STLY_ADR + STLY_ADR;
                                                }

                                                if (STLY_AVG_Lead_Time > 0) {
                                                    Total_STLY_AVG_Lead_Time_Count =
                                                        Total_STLY_AVG_Lead_Time_Count + 1;
                                                    Total_STLY_AVG_Lead_Time =
                                                        Total_STLY_AVG_Lead_Time + STLY_AVG_Lead_Time;
                                                }

                                                Total_STLY_OTB = Total_STLY_OTB + STLY_OTB;
                                                Total_STLY_Revenue = Total_STLY_Revenue + STLY_Revenue;
                                                Total_STLY_AVG_Rate =
                                                    Total_STLY_AVG_Rate + STLY_AVG_Rate;

                                                if (LY_ADR > 0) {
                                                    Total_LY_ADR_Count = Total_LY_ADR_Count + 1;
                                                    Total_LY_ADR = Total_LY_ADR + LY_ADR;
                                                }

                                                if (LY_AVG_Lead_Time > 0) {
                                                    Total_LY_AVG_Lead_Time_Count =
                                                        Total_LY_AVG_Lead_Time_Count + 1;
                                                    Total_LY_AVG_Lead_Time =
                                                        Total_LY_AVG_Lead_Time + LY_AVG_Lead_Time;
                                                }

                                                Total_LY_OTB = Total_LY_OTB + LY_OTB;
                                                Total_LY_Revenue = Total_LY_Revenue + LY_Revenue;
                                                Total_LY_AVG_Rate = Total_LY_AVG_Rate + LY_AVG_Rate;
                                            }
                                        }

                                        let STLY_ADR_Variance = parseFloat(singleOTBData?.[0]?.ADR ? singleOTBData?.[0]?.ADR : 0) - parseFloat(STLY_ADR ? STLY_ADR : 0);
                                        let STLY_OTB_Variance = parseInt(singleOTBData?.[0]?.OnTheBook ? singleOTBData?.[0]?.OnTheBook : 0) - parseInt(STLY_OTB ? STLY_OTB : 0);
                                        let STLY_Revenue_Variance = parseFloat(singleOTBData?.[0]?.REV ? singleOTBData?.[0]?.REV : 0) - parseFloat(STLY_Revenue ? STLY_Revenue : 0);

                                        let LY_ADR_Variance = parseFloat(singleOTBData?.[0]?.ADR ? singleOTBData?.[0]?.ADR : 0) - parseFloat(LY_ADR ? LY_ADR : 0);
                                        let LY_OTB_Variance = parseInt(singleOTBData?.[0]?.OnTheBook ? singleOTBData?.[0]?.OnTheBook : 0) - parseInt(LY_OTB ? LY_OTB : 0);
                                        let LY_Revenue_Variance = parseFloat(singleOTBData?.[0]?.REV ? singleOTBData?.[0]?.REV : 0) - parseFloat(LY_Revenue ? LY_Revenue : 0);

                                        return (
                                            <React.Fragment key={index}>
                                                <tr
                                                    key={index}
                                                    className={`${dayName ? "backgroundTr" : ""
                                                        } shadowOnHover`}
                                                >
                                                    <td className="">
                                                        <div className="d-flex gap-1">
                                                            {flagType ? (
                                                                flagType
                                                            ) : (
                                                                <div style={{ height: "11px", width: "11px" }}>
                                                                    {" "}
                                                                </div>
                                                            )}

                                                            <div className="d-flex gap-4">
                                                                {commonService.getDateInFormat(
                                                                    item,
                                                                )}{" "}
                                                                {moment(
                                                                    new Date(item),
                                                                    "l",
                                                                ).format("ddd")}
                                                                <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                                    {checkEvent?.length > 0 && (
                                                                        <img id={commonService.generateGlobalClickTrackerID("RecommendedRate", "ticket", item)}
                                                                            style={{ height: "11px", width: "11px" }}
                                                                            className="iconcolor"
                                                                            src={ticket}
                                                                            alt="ticket"
                                                                            onClick={() => {
                                                                                selectedEventDateRef.current = item;
                                                                                eventListPropsRef.current = checkEvent;
                                                                                setShowTicketModal(true);
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {singleRecommendedData?.[0]?.promo_flag && (
                                                                <img
                                                                    title={singleRecommendedData?.[0]?.promo_flag}
                                                                    id={commonService.generateGlobalClickTrackerID(
                                                                        "RecommendedRate",
                                                                        "promoIcon",
                                                                        item
                                                                    )}
                                                                    style={{
                                                                        height: "11px",
                                                                        width: "11px",
                                                                        marginLeft: "auto",
                                                                    }}
                                                                    className="iconcolor"
                                                                    src={promo}
                                                                    alt="promo"
                                                                />
                                                            )}
                                                        </div>
                                                    </td>

                                                    <td className="text-center border-right">
                                                        {singleOTBData?.[0]?.OOO ? singleOTBData?.[0]?.OOO : 0}\{singleOTBData?.[0]?.RoomAvailable ? singleOTBData?.[0]?.RoomAvailable : 0}
                                                    </td>
                                                    <td
                                                        className="text-primary text-center"
                                                        value={
                                                            singleOTBData?.[0]?.OnTheBook
                                                                ? commonService.formateRoom(
                                                                    singleOTBData?.[0]?.OnTheBook,
                                                                )
                                                                : 0
                                                        }
                                                    >
                                                        <span id={commonService.generateGlobalClickTrackerID("RecommendedRate", "on-the-books-otb", item)}
                                                            className={`${selectedTdIndexRef.current === index
                                                                ? "singleDateSummarySpan"
                                                                : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                singleDateSelectedDateRef.current = item;

                                                                handleFilterBtnClick(e);
                                                                selectedTdIndexRef.current = index;
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {singleOTBData?.[0]?.OnTheBook
                                                                ? singleOTBData?.[0]?.OnTheBook
                                                                : 0}
                                                        </span>
                                                    </td>
                                                    <td
                                                        className={"text-center perbackground TotalOCCPercentage"}
                                                        value={
                                                            singleOTBData?.[0]?.TotalOCCPercentage
                                                                ? singleOTBData?.[0]?.TotalOCCPercentage
                                                                : 0
                                                        }
                                                    >
                                                        {singleOTBData?.[0]?.TotalOCCPercentage
                                                            ? singleOTBData?.[0]?.TotalOCCPercentage
                                                            : 0}
                                                        %
                                                    </td>
                                                    <td
                                                        className="text-end"
                                                        value={singleOTBData?.[0]?.ADR}
                                                    >
                                                        {singleOTBData?.[0]?.ADR
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.ADR,
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {singleOTBData?.[0]?.REV
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.REV,
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="text-end">
                                                        {singleOTBData?.[0]?.RevPAR
                                                            ? commonService.formateAmount(
                                                                singleOTBData?.[0]?.RevPAR,
                                                            )
                                                            : commonService.formateAmount(0)}
                                                    </td>


                                                    {/* // Forecast */}
                                                    {rateShopListData && (
                                                        <td className="border-right text-center">
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                <lable id={commonService.generateGlobalClickTrackerID("RecommendedRate", "FC-OCC-lable-td-onclick", item)}
                                                                    className={`${selectedForecast === "ema" && "cursor-pointer"} ${foreCastSpiderTextColor} ${forecastSpiderBorder} m-0`}
                                                                    style={{ padding: "2px" }}
                                                                    onClick={(e) => {
                                                                        if (selectedForecast !== "ema") {
                                                                            return e.preventDefault();
                                                                        }
                                                                        singleDateSelectedDateRef.current = item;
                                                                        handlePricingForecastBtnClick(e);
                                                                        selectedTdIndexRef.current = index;
                                                                    }}
                                                                >
                                                                    {singleForecastData?.[0]?.RMS
                                                                        ? commonService.formateRoom(
                                                                            singleForecastData?.[0]?.RMS,
                                                                        )
                                                                        : 0}
                                                                </lable>
                                                            </div>
                                                        </td>
                                                    )}


                                                    {rateShopListData && (
                                                        <>
                                                            {/* Comp Set */}
                                                            <td className="text-end border-right">
                                                                {commonService.formateAmount(STLY_AVG_Rate)}
                                                            </td>
                                                            {/* AVG */}
                                                            <td id={commonService.generateGlobalClickTrackerID("RecommendedRate", "compset-avg-td-onclick", item)}
                                                                className="text-end cursorPointer"
                                                                onClick={() => {
                                                                    setClickedDate(item);
                                                                    setToolsSummaryModal(true);
                                                                }}
                                                            >
                                                                {avgCompetitor
                                                                    ? `${commonService.formateAmount(
                                                                        avgCompetitor,
                                                                    )}`
                                                                    : `${commonService.formateAmount(0)}`}{" "}
                                                            </td>
                                                            <td
                                                                className={`text-end fontsize10px minwidth30px ${avgCompetitorRateDiff ? (avgCompetitorRateDiff > 0 ? "greenText" : "redText") : ""}`}
                                                            >
                                                                {avgCompetitorRateDiff
                                                                    ? commonService.formateAmount(
                                                                        avgCompetitorRateDiff,
                                                                    )
                                                                    : ""}{" "}
                                                            </td>

                                                            {/* Pricing */}
                                                            {/* BAR Column */}
                                                            <td
                                                                className={`text-end border-right ${isSelfData?.[0]?.Rate < avgCompetitor
                                                                    ? "greenText"
                                                                    : "redText"
                                                                    }`}
                                                            >
                                                                {isSelfData?.length > 0 ? (
                                                                    <>
                                                                        {parseInt(isSelfData[0]?.RateStatusCode) ===
                                                                            201 ? (
                                                                            <img
                                                                                className="cursorPointer"
                                                                                src={soldOutIcon}
                                                                                alt="soldout"
                                                                            />
                                                                        ) : isSelfData[0]?.Rate ? (
                                                                            <span
                                                                                title={`${parseFloat(isSelfData[0]?.Rate) <= 0 && isSelfData[0]?.RateStatusDesc ? isSelfData[0]?.RateStatusDesc : ""}`}
                                                                            >{`${commonService.formateAmount(Math.round(isSelfData[0]?.Rate))}`}</span>
                                                                        ) : (
                                                                            <span
                                                                                title={`${isSelfData[0]?.RateStatusDesc ? isSelfData[0]?.RateStatusDesc : ""}`}
                                                                            >{`${commonService.formateAmount(0)}`}</span>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    commonService.formateAmount(0)
                                                                )}
                                                            </td>
                                                            <td
                                                                className={`text-end fontsize10px minwidth30px ${SelfDataRateDiff ? (SelfDataRateDiff > 0 ? "greenText" : "redText") : ""}`}
                                                            >
                                                                {SelfDataRateDiff
                                                                    ? commonService.formateAmount(
                                                                        SelfDataRateDiff,
                                                                    )
                                                                    : ""}
                                                            </td>
                                                        </>
                                                    )}

                                                    <td className="border-right text-center text-primary cursor-pointer">
                                                        <span id={commonService.generateGlobalClickTrackerID("RecommendedRate", "rec-rate-td-onclick", item)}
                                                            className="d-flex justify-content-center"
                                                            onClick={(e) => {
                                                                selectedData.current = {
                                                                    compset_avg:
                                                                        commonService.formateAmount(avgCompetitor),
                                                                    optimal_bar: singleRecommendedData?.[0]
                                                                        ?.ota_finalrate
                                                                        ? singleRecommendedData?.[0]?.ota_finalrate
                                                                        : 0,
                                                                    dates: singleRecommendedData?.[0]?.staydate,
                                                                    predictedrate: singleRecommendedData?.[0]
                                                                        ?.ota_finalrate
                                                                        ? singleRecommendedData?.[0]?.ota_finalrate
                                                                        : 0,
                                                                };
                                                                handleDetailAnalysisClick(e);
                                                            }}
                                                        >
                                                            {isSelfData?.length > 0 && (
                                                                <>
                                                                    {parseInt(isSelfData[0]?.RateStatusCode) ===
                                                                        201 ? (
                                                                        <img
                                                                            className="cursorPointer"
                                                                            src={soldOutIcon}
                                                                            alt="soldout"
                                                                        />
                                                                    ) : (
                                                                        isSelfData[0]?.Rate && (
                                                                            <span
                                                                                title={
                                                                                    parseFloat(isSelfData[0]?.Rate) <=
                                                                                        0 && isSelfData[0]?.RateStatusDesc
                                                                                        ? isSelfData[0]?.RateStatusDesc
                                                                                        : ""
                                                                                }
                                                                                className="d-flex align-items-center gap-1"
                                                                            >
                                                                                {commonService.formateAmount(
                                                                                    Math.round(
                                                                                        singleRecommendedData?.[0]
                                                                                            ?.ota_finalrate,
                                                                                    ),
                                                                                )}

                                                                                {Number(isSelfData[0]?.Rate) >
                                                                                    Number(
                                                                                        singleRecommendedData?.[0]
                                                                                            ?.ota_finalrate,
                                                                                    ) && <UpArrow />}

                                                                                {Number(isSelfData[0]?.Rate) <
                                                                                    Number(
                                                                                        singleRecommendedData?.[0]
                                                                                            ?.ota_finalrate,
                                                                                    ) && <DownArrow />}

                                                                                {Number(isSelfData[0]?.Rate) ===
                                                                                    Number(
                                                                                        singleRecommendedData?.[0]
                                                                                            ?.ota_finalrate,
                                                                                    ) && <EqualIcon />}
                                                                            </span>
                                                                        )
                                                                    )}
                                                                </>
                                                            )}
                                                        </span>
                                                    </td>


                                                    <td className="text-center border-right">{STLY_OTB}</td>
                                                    <td className={`text-center ${STLY_OTB_Variance > 0 ? "greenText" : "redText"}`}> {STLY_OTB_Variance ? STLY_OTB_Variance : ""} </td>
                                                    <td className="text-end border-right">{commonService.formateAmount(STLY_ADR)}</td>
                                                    <td className={`text-end ${STLY_ADR_Variance > 0 ? "greenText" : "redText"}`}> {STLY_ADR_Variance ? commonService.formateAmount(STLY_ADR_Variance) : ""} </td>
                                                    <td className="text-end border-right">{commonService.formateAmount(STLY_Revenue)}</td>
                                                    <td className={`text-end ${STLY_Revenue_Variance > 0 ? "greenText" : "redText"}`}> {STLY_Revenue_Variance ? commonService.formateAmount(STLY_Revenue_Variance) : ""} </td>
                                                    <td className="text-center border-right">{STLY_AVG_Lead_Time}</td>



                                                    <td className="text-center border-right">{LY_OTB}</td>
                                                    <td className={`text-center ${LY_OTB_Variance > 0 ? "greenText" : "redText"}`}> {LY_OTB_Variance ? LY_OTB_Variance : ""} </td>
                                                    <td className="text-end border-right">{commonService.formateAmount(LY_ADR)}</td>
                                                    <td className={`text-end ${LY_ADR_Variance > 0 ? "greenText" : "redText"}`}> {LY_ADR_Variance ? commonService.formateAmount(LY_ADR_Variance) : ""} </td>
                                                    <td className="text-end border-right">{commonService.formateAmount(LY_Revenue)}</td>
                                                    <td className={`text-end ${LY_Revenue_Variance > 0 ? "greenText" : "redText"}`}> {LY_Revenue_Variance ? commonService.formateAmount(LY_Revenue_Variance) : ""} </td>
                                                    <td className="text-center border-right">{LY_AVG_Lead_Time}</td>

                                                </tr>
                                                {startDateArrayRef.current?.length - 1 === index && (
                                                    <tr className="shadowOnHover">
                                                        <td className="boldTd"> Total </td>
                                                        <td className="boldTd border-right text-center">
                                                            {commonService.formateRoom(ooo)} \ {commonService.formateRoom(RmsAvailable)}
                                                        </td>
                                                        <td className="boldTd text-center">{OTB_totalOTB}</td>
                                                        <td className="boldTd text-center">
                                                            {OTB_totalOCC > 0
                                                                ? `${Math.round((OTB_totalOCC / startDateArrayRef.current?.length))}%`
                                                                : "0%"}
                                                        </td>
                                                        <td className="boldTd text-end">
                                                            {OTB_totalOTB > 0
                                                                ? commonService.formateAmount((OTB_totalREV / OTB_totalOTB))
                                                                : 0}
                                                        </td>
                                                        <td className="boldTd text-end">{commonService.formateAmount(OTB_totalREV)}</td>
                                                        <td className="boldTd text-end">
                                                            {revPar > 0
                                                                ? commonService.formateAmount(revPar / startDateArrayRef.current?.length)
                                                                : commonService.formateAmount(0)}
                                                        </td>

                                                        <td className="boldTd border-right"></td>

                                                        <td className="boldTd"></td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd"></td>
                                                        <td className="boldTd"></td>

                                                        <td className="boldTd text-center border-right">
                                                            {Total_STLY_OTB}
                                                        </td>
                                                        <td className="boldTd text-center">
                                                            {parseInt(OTB_totalOTB ? OTB_totalOTB : 0) - parseInt(Total_STLY_OTB ? Total_STLY_OTB : 0)}
                                                        </td>
                                                        <td className="boldTd text-end ">
                                                            {Total_STLY_OTB > 0
                                                                ? commonService.formateAmount(
                                                                    safeDivide(Total_STLY_Revenue, Total_STLY_OTB)
                                                                )
                                                                : commonService.formateAmount(0)}

                                                        </td>
                                                        <td className="boldTd text-end ">
                                                            {commonService.formateAmount(parseFloat(OTB_totalOTB > 0 ? (OTB_totalREV / OTB_totalOTB) : 0) - parseFloat(Total_STLY_OTB > 0 ? safeDivide(Total_STLY_Revenue, Total_STLY_OTB) : 0))}
                                                        </td>

                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(Total_STLY_Revenue)}
                                                        </td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(parseFloat(OTB_totalREV ? OTB_totalREV : 0) - parseFloat(Total_STLY_Revenue ? Total_STLY_Revenue : 0))}
                                                        </td>
                                                        <td className="boldTd text-center">
                                                            {Total_STLY_AVG_Lead_Time > 0
                                                                ? parseInt(
                                                                    Total_STLY_AVG_Lead_Time /
                                                                    Total_STLY_AVG_Lead_Time_Count
                                                                )
                                                                : 0}
                                                        </td>

                                                        <td className="boldTd text-center border-right">
                                                            {Total_LY_OTB}
                                                        </td>
                                                        <td className="boldTd text-center">
                                                            {parseInt(OTB_totalOTB ? OTB_totalOTB : 0) - parseInt(Total_LY_OTB ? Total_LY_OTB : 0)}
                                                        </td>
                                                        <td className="boldTd text-end ">
                                                            {Total_LY_OTB > 0
                                                                ? commonService.formateAmount(
                                                                    safeDivide(Total_LY_Revenue, Total_LY_OTB)
                                                                )
                                                                : commonService.formateAmount(0)}

                                                        </td>
                                                        <td className="boldTd text-end ">
                                                            {commonService.formateAmount(parseFloat(OTB_totalOTB > 0 ? (OTB_totalREV / OTB_totalOTB) : 0) - parseFloat(Total_STLY_OTB > 0 ? safeDivide(Total_LY_Revenue, Total_LY_OTB) : 0))}
                                                        </td>
                                                        <td className="boldTd text-end">
                                                            {commonService.formateAmount(Total_LY_Revenue)}
                                                        </td>
                                                        <td className="boldTd text-end ">
                                                            {commonService.formateAmount(parseFloat(OTB_totalREV ? OTB_totalREV : 0) - parseFloat(Total_LY_Revenue ? Total_LY_Revenue : 0))}
                                                        </td>
                                                        <td className="boldTd text-center">
                                                            {Total_LY_AVG_Lead_Time > 0
                                                                ? parseInt(
                                                                    Total_LY_AVG_Lead_Time /
                                                                    Total_LY_AVG_Lead_Time_Count
                                                                )
                                                                : 0}
                                                        </td>
                                                      
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                {showTicketModal && (
                    <EventViewModal
                        showModal={showTicketModal}
                        closeModal={closeTicketModal}
                        eventDetails={eventListPropsRef.current}
                        selectedDate={selectedEventDateRef.current}
                        getEventList={getEventList}
                    />
                )}
            </div>
            {api !== 0 && <Comments widgetDetails={para} editorId={"ORG"} />}

            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 11 }}
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            // pickupDate={
                            //   selectPickupDate
                            //     ? selectPickupDate
                            //     : singleDatePickupDateRef.current
                            // }
                            pickupDate={
                                selectSevenPickupDate
                                    ? selectSevenPickupDate
                                    : sevenMaxDateRef.current
                            }
                            propertyDetail={{ propertyCode: para?.propertyCode }}
                        />
                    </div>
                </Popover>
            </Overlay>

            <Overlay
                show={groupModal.IsDisplay}
                target={groupModal.Target}
                placement={groupModal.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div className="horizontal-menu-option active singleDayGroupSummary">
                        <SingleDayGroupModal
                            closeModal={closeGroupDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            propertyCode={propertyCode}
                        />
                    </div>
                </Popover>
            </Overlay>

            {/* Overlay for Pricing & Forecast > System Forcast */}
            <Overlay
                show={pricingForcastModal.IsDisplay}
                target={pricingForcastModal.Target}
                placement={pricingForcastModal.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div className="horizontal-menu-option active singleDayGroupSummary">
                        <SingleDayPricingForcastModal
                            closeModal={closePricingForecastDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            propertyCode={propertyCode}
                        />
                    </div>
                </Popover>
            </Overlay>

            {showNoteSidebar && (
                <WidgetNote
                    show={showNoteSidebar}
                    handleClose={closeNoteSideBar}
                    // widgetId={para?.widgetId}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                    dateForNote={clickedDateForNote.current}
                />
            )}
            {addNoteModal && (
                <AddWidgetModal
                    showModal={addNoteModal}
                    closeModal={closeNoteModal}
                    // widgetId={para?.widgetId}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
            {flagModal && (
                <FlagPopup
                    showModal={flagModal}
                    closeModal={() => setFlagModal(false)}
                    data={flagModalData}
                />
            )}
            {showToolsSummaryModal && (
                <ToolsSummaryModal
                    showToolsSummaryModal={showToolsSummaryModal}
                    closeToolsSummaryModal={closeToolsSummaryModal}
                    selectedDate={ClickedDate}
                    propertyDetail={propertyDetailFromRTK}
                />
            )}

            {DetailedAnalysis.IsDisplay && (
                <PriceSimulatorDetailAnalysis
                    show={DetailedAnalysis.IsDisplay}
                    closeModal={closeDetailedAnalysisModal}
                    data={{
                        asOfDate: para?.asOfDate,
                        propertyCode: para?.propertyCode,
                        selectedItem: selectedData.current,
                    }}
                />
            )}
        </div>
    );
};

export default RecommendedRate;
